import { Layers, ListOrdered } from 'lucide-react';

export function CourseStructureV3Panel({ data }) {
  if (!data?.modules?.length) return null;

  return (
    <div className="space-y-4">
      {data.structure_summary ? (
        <p className="text-sm text-slate-400">{data.structure_summary}</p>
      ) : null}
      <div className="flex items-center gap-4 text-xs text-slate-500">
        <span className="flex items-center gap-1">
          <Layers className="w-3.5 h-3.5" />
          {data.module_count} modules
        </span>
        <span className="flex items-center gap-1">
          <ListOrdered className="w-3.5 h-3.5" />
          {data.concept_count} concepts
        </span>
      </div>
      <ol className="space-y-3">
        {data.modules.map((mod) => (
          <li
            key={mod.module_id}
            className="rounded-lg border border-slate-700/60 bg-slate-900/40 p-3"
          >
            <div className="flex items-start justify-between gap-2">
              <div>
                <p className="text-sm font-medium text-slate-200">
                  {mod.sequence_order}. {mod.title}
                </p>
                {mod.objective ? (
                  <p className="text-xs text-slate-500 mt-1">{mod.objective}</p>
                ) : null}
              </div>
              <span className="text-[10px] text-slate-500 shrink-0">
                ~{mod.estimated_duration_minutes}m
              </span>
            </div>
            <p className="text-xs text-violet-300/80 mt-2">
              {(mod.concept_names || []).join(' → ')}
            </p>
          </li>
        ))}
      </ol>
    </div>
  );
}
